export const TYPING_PREVIEW_MAX_LENGTH = 2000;
export const TYPING_PREVIEW_INTERVAL_MS = 300;
export const TYPING_PREVIEW_IDLE_MS = 4000;
export const TYPING_PREVIEW_EXPIRY_MS = 6000;
